import { useDispatch, useSelector } from "react-redux";
import { Alert, Snackbar } from "@mui/material";
import { useEffect, useState, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { setExceedFilterWarning } from "Redux/Slices/Common";

import Content from "Explore/Layout/Content/Content";
import SubscribedSidebar from "./SubscribedSidebar";
import SubscribedTopbar from "./SubscribedTopbar";
import { CompareSelectionProvider } from "Explore/Context/CompareSelectionContext";
import { Toaster } from "components/ui/toast";

const LayoutSubscribed = () => {
  const dispatch = useDispatch();
  const { exceedFilterWarning } = useSelector((state) => state.commonState) || {};
  const navigate = useNavigate();
  const location = useLocation();
  const mainRef = useRef(null);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);
  const [collapsedByAssistant, setCollapsedByAssistant] = useState(false);

  useEffect(() => {
    if (mainRef.current) {
      mainRef.current.scrollTop = 0;
    }
    window.scrollTo(0, 0);
  }, [location.pathname]);

  const handleToggleSidebar = () => {
    setSidebarCollapsed((prev) => {
      setCollapsedByAssistant(false);
      return !prev;
    });
  };

  useEffect(() => {
    if (exceedFilterWarning) {
      setSnackbarOpen(true);
    }
  }, [exceedFilterWarning]);

  const handleCloseSnackBar = () => {
    setSnackbarOpen(false);
    dispatch(setExceedFilterWarning(false));
  };

  const handleLogin = () => {
    dispatch(setExceedFilterWarning(false));
    const currentPath = location.pathname + location.search;
    navigate(`/login`, { state: { previousPage: currentPath } });
  };

  useEffect(() => {
    const autoCollapsePaths = [
      "/explore/assistant",
      "/explore/my-library",
      "/explore/collaborations",
      "/explore/analysis",
      "/explore/peer",
      "/explore/report-detail",
      "/explore/faculties",
      "/explore/institutions",
      "/explore/units",
      "/explore/venues",
      "/analysis",
      "/explore/settings",
      "/explore/help",
      "/explore/mcp-server",
      "/explore/mcp"
    ];
    
    const shouldCollapse = autoCollapsePaths.some(path => location.pathname.startsWith(path));

    if (shouldCollapse) {
      if (!sidebarCollapsed) {
        setSidebarCollapsed(true);
        setCollapsedByAssistant(true);
      }
    } else {
      if (collapsedByAssistant) {
        setSidebarCollapsed(false);
        setCollapsedByAssistant(false);
      }
    }
  }, [location.pathname]);

  useEffect(() => {
    if (location.pathname === "/explore" || location.pathname === "/explore/") {
      navigate("/explore/overview", { replace: true });
    }
  }, [location.pathname, navigate]);

  return (
    <>
      <CompareSelectionProvider>
        <div className="flex h-screen w-full overflow-hidden bg-white text-zinc-900 font-sans">
          <SubscribedSidebar
            collapsed={sidebarCollapsed}
            onToggle={handleToggleSidebar}
            isMobile={false}
          />
          <div className="flex-1 flex flex-col min-w-0 h-full overflow-hidden bg-white">
            <SubscribedTopbar />
            <main ref={mainRef} className="flex-1 overflow-y-auto bg-zinc-50 shadow-sm">
              <Content />
            </main>
          </div>
        </div>
      </CompareSelectionProvider>
      <Snackbar
        open={snackbarOpen}
        autoHideDuration={4000}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
        onClose={handleCloseSnackBar}
      >
        <Alert
          onClose={handleCloseSnackBar}
          severity="warning"
          variant="filled"
          sx={{ width: "100%" }}
        >
          Maximum filters reached.{" "}
          <span
            style={{ textDecoration: "underline", cursor: "pointer" }}
            onClick={() => handleLogin()}
          >
            Log in
          </span>{" "}
          to apply more!
        </Alert>
      </Snackbar>
      <Toaster />
    </>
  );
};

export default LayoutSubscribed;
